import Vue from 'vue'
import {Loading, Message, MessageBox, Notification} from 'element-ui'


let notifyOffset = 25; // 初始偏移量
/**
 * @description 自定义全局 Notification
 * @param {*} title //标题
 * @param {*} message //信息
 * @param {*} type //类型(success,warning,info,error)
 * @param {*} duration //显示时间(毫秒,1秒=1000毫秒)
 * @param {*} position  //位置(top-right代表右上角...)
 */
Vue.prototype.$elNotify = function (title, message, type='info', duration=2000, position='top-right') {
  //标题，信息，类型(success,warning,info,error)，位置(top-right...)，显示时间(毫秒)。
  //例如('提示标题','提示信息', 'info', 'top-right', 3000)。
  Notification({
    title: title || '默认标题',
    message: message || '默认信息',
    type: type || 'info',
    duration: duration || 2000,
    position: position || 'top-right',//位置，默认右上角
    offset: notifyOffset, // 使用偏移量控制消息的位置
  })
  notifyOffset += 25; // 每次显示消息后增加偏移量，确保下一条消息显示在上一条消息的下方
  setTimeout(function () {
    notifyOffset -= 25
  }, duration); // 在2秒后执行
}



let messageOffset = 20; // 初始偏移量
/**
 * @description 自定义全局 Message
 * @param {*} message //信息
 * @param {*} type //类型(success,warning,info,error)
 */
Vue.prototype.$elMessage = function (message, type='info') {
  Message({
    showClose: true,
    message: message || '默认信息',
    type: type || 'info',// 消息类型，可以是 success、warning、info 或 error
    offset: messageOffset, // 使用偏移量控制消息的位置
    customClass:'zby-el-custom-message-'+type,//自定义类名(在init.scss文件里面)
  })
  messageOffset += 20; // 每次显示消息后增加偏移量，确保下一条消息显示在上一条消息的下方
  setTimeout(function () {
    messageOffset -= 20
  }, 2000); // 在3秒后执行
}



/**
 * @description 自定义全局 MessageBox
 * @param {*} title //标题
 * @param {*} message //信息
 * @param {*} type //类型(success,warning,info,error)
 * @param {*} confirmButtonText //确认按钮的文字
 * @param {function} confirmButton //点击 确认按钮 后执行的方法
 * @param {function} xButton //点击 x按钮 后执行的方法
 */
Vue.prototype.$elMessageBox = function (title, message, type='info', confirmButtonText='确定',confirmButton=()=>{}, xButton=()=>{}) {
  MessageBox({
    title: title || '默认标题',
    message: message || '默认信息',
    type: type || 'info',
    confirmButtonText: confirmButtonText || '确定',
    showCancelButton: true,
    cancelButtonText: '取消',
  })
    .then(() => {
      if (confirmButton) {
        confirmButton()
      }
      //点击确认按钮后执行，可以写一些操作
      // () => {
      //   this.$message({
      //     type: 'success',
      //     message: '保存修改'
      //   });
    })
    .catch(() => {
      if (xButton) {
        xButton()
      }
      //点击右上角的x后执行，可以写一些操作
    })
}



/**
 * @description 全局loading加载层
 * @param {*} index 1~9
 * @param {*} text
 */
Vue.prototype.$elLoading = (index, text) => {
  let loading
  if (!index) {
    loading = Loading.service({
      lock: true,
      text: text || '正在加载中...',
      background: 'hsla(0,0%,100%,.8)',
    })
  } else {
    loading = Loading.service({
      lock: true,
      text: text || '正在加载中...',
      spinner: 'custom-loading-type' + index,
      background: 'hsla(0,0%,100%,.8)',
    })
  }
  return loading
}

/**
 * @description 全局多彩loading加载层
 * @param {*} index 1~4
 * @param {*} text
 */
Vue.prototype.$elColorFullLoading = (index, text) => {
  let loading
  if (!index) {
    loading = Loading.service({
      lock: true,
      text: text || '正在加载中...',
      spinner: 'dots-loader',
      background: 'hsla(0,0%,100%,.8)',
    })
  } else {
    switch (index) {
      case 1:
        index = 'dots'
        break
      case 2:
        index = 'gauge'
        break
      case 3:
        index = 'inner-circles'
        break
      case 4:
        index = 'plus'
        break
    }
    loading = Loading.service({
      lock: true,
      text: text || '正在加载中...',
      spinner: index + '-loader',
      background: 'hsla(0,0%,100%,.8)',
    })
  }
  return loading
}

export default {}
